import PropTypes from 'prop-types';
import React from 'react';
import {ArchitectureType} from '@account/utils/entitlements';
import {Chip} from '@mui/material';

const chipStyles = {
  [ArchitectureType.WORKSPACE]: {
    label: 'Workspace',
    sx: {
      backgroundColor: 'primary.lighter',
      color: 'primary.dark',
      fontWeight: 600,
      fontSize: '0.7rem',
    },
  },
  [ArchitectureType.CLASSIC]: {
    label: 'Classic',
    sx: {
      backgroundColor: 'grey.200',
      color: 'grey.700',
      fontWeight: 600,
      fontSize: '0.7rem',
    },
  },
};

const ArchitectureChip = ({architecture, ...props}) => {
  const config =
    chipStyles[architecture] || chipStyles[ArchitectureType.CLASSIC];

  return (
    <Chip
      label={config.label}
      size="small"
      sx={config.sx}
      data-qe="architecture-chip"
      {...props}
    />
  );
};

ArchitectureChip.propTypes = {
  architecture: PropTypes.oneOf(Object.values(ArchitectureType)),
};

export default ArchitectureChip;
